import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IPresentationType } from "../interfaces/ipresentationType";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class PresentationTypeService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Get a list of all updates
     */
    getAll(): Observable<IPresentationType[]> {
        return super.get(`/api/presentationtype`).pipe(map((res: any) => res));
    }

}






